<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item label="是否为会员: " style="margin:0 30PX">
        <el-select style="width:260px" v-model="selectForm.is_vip" placeholder="请选择" @change="selecCategoryBtn"
          clearable>
          <div v-for="item in statusArr" :key="item.id">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left:20px">
        <el-input v-model="selectForm.phone" placeholder="请输入商品名称" style="width:250px" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectAll">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleData">总用户数: {{goodsArr.length}}</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <el-table border :data="goodsArr" style="width: 100%;overflow-y: scroll;" height="calc(100vh - 220px)"
      v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="正在加载中">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="用户openid" width="300" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.openid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否为会员" width="100" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.is_vip === 0 ? "否" : scope.row.is_vip === 1 ? "是" : "-"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="积分余额" min-width="50" align="center">
        <template slot-scope="scope">
          <el-tag>{{
            scope.row.money ? scope.row.money : 0
            }}</el-tag>
        </template>
      </el-table-column>
      <!-- TODO:会员订单,付款金额 -->
      <!-- <el-table-column label="手机号" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="创建时间" min-width="180" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleMoneyPop(scope.row)">操作积分</el-button>
          <el-button size="mini" type="success" @click="ejectupdataGoods(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleteGoods(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 产品提交表单 -->
    <el-dialog :title="inpitTypeName" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.phone" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="是否为会员: " :label-width="formLabelWidth" required>
          <el-select v-model="form.is_vip" placeholder="请选择" style="width: 100%;">
            <div v-for="item in isVipList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 产品提交表单 -->
    <el-dialog title="充值或消费" :visible.sync="dialogFormVisible_money" :close-on-click-modal="false">
      <el-form :model="form">
        <el-form-item label="手机号" :label-width="formLabelWidth" required>
          <el-input v-model="form.phone" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型: " :label-width="formLabelWidth" required>
          <el-select v-model="form.type" placeholder="请选择" style="width: 100%">
            <div v-for="item in typeList" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="金额" :label-width="formLabelWidth" required>
          <el-input v-model.number="form.amount" auto-complete="off" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" required>
          <el-input v-model="form.remark" auto-complete="off" type="textarea" :rows="5"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible_money = false">取 消</el-button>
        <el-button type="primary" @click="handleMoney">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  selectallUser,
  deleteUser,
  updateUser,
} from "@/services/marketing/vipUser";
import { IP } from "@/services/index.js";
import {
  addOrReduceBalance,
} from "@/services/marketing/moneyRecord";

// import { addSku, selectSku, deleteSku } from "@/services/sku";
export default {
  created() {
    this.selectAll();
  },

  data() {
    return {
      dialogFormVisible_money: false,
      typeList: [
        {
          id: 1,
          name: "充值",
        },
        {
          id: 2,
          name: "消费",
        },
      ],
      selectForm: {},
      status: 0,
      statusArr: [
        { id: 0, name: "否" },
        { id: 1, name: "是" },
      ],
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      isVipList: [
        {
          id: 0,
          name: "否",
        },
        {
          id: 1,
          name: "是",
        },
      ],
      nextCategoryArr: [],
      goodsArr: [],
      dialogFormVisible: false, //产品信息维护
      dialogImgVisible: false, //产品图维护
      imgEditVisible: false,
      imgObj: {},
      formLabelWidth: "120px",
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: true,
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: "",
      },
      skuVisible: false,
    };
  },
  methods: {
    selectAll() {
      selectallUser({
        ...this.selectForm,
        phone: this.selectForm.phone ? this.selectForm.phone : "",
      }).then((resp) => {

        this.loading = false;
        this.goodsArr = resp.data;

      });
    },
    // 根据分类id查二级分类
    selecCategoryBtn(e) {
      this.selectAll();
    },

    coverImgBtn(e) {
      this.form.coverImg = e.data;
    },
    /* 编辑图片 */
    updateImgBtn(e) {
      this.fileList = [];
      this.imgObj.imgUrl = e.data;
    },

    /*  移除上传的内容 */
    handleRemove(e, fileList) {
      console.log("移除---------------", e, fileList);
    },
    handleMoneyPop(row) {
      this.dialogFormVisible_money = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    ejectupdataGoods(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改用户信息";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },

    ejectaddGoods() {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增商品";
      this.form = {};
      this.select_one_id = "";
      this.fileList = [];
    },

    ejectupdataImgs(row) {

      this.dialogImgVisible = true;
      this.inpitTypeName = "商品图片维护";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      //查询
      this.handleSeletImg();
      this.handleSeletDeatilImg();
    },

    /* 编辑图片弹窗 */
    handleEditImg(row) {

      this.fileList = [];
      this.imgEditVisible = true;
      this.imgObj = JSON.parse(JSON.stringify(row));
    },

    /* 提交商品详情按钮 */
    updataBtn() {
      if (this.form.is_vip !== 0 && this.form.is_vip !== 1) {
        this.$message.error("请选择");
        return;
      }
      if (this.inpitTypeName == "修改用户信息") {
        updateUser(this.form).then((resp) => {
          if (resp.code == 200) {
            this.$message.success("修改成功");
            this.dialogFormVisible = false;
            this.selectAll();
          } else {
            this.$message.error("修改失败");
          }
        });
        return;
      }
    },

    /* 充值或消费 */
    handleMoney() {
      if (!this.form.type || !this.form.amount || !this.form.remark) {
        this.$message.error("选择不能为空");
        return;
      }
      addOrReduceBalance(this.form).then((resp) => {
        if (resp.code == 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible_money = false;
          this.selectAll();
        } else {
          this.$message.error(resp.message);
        }
      });
    },


    /* 删除商品 */
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteUser(row.id).then((resp) => {

            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectAll();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    handleData(){
      this.$router.push("/system/dashboard")
    }
  },
};
</script>

<style scoped>
.content {
  margin: 10px auto;
  width: 98%;
}

.demo-form-inline {
  margin: 20px 0 0;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.goodsTitle:hover {
  cursor: pointer;
}

.upload-demo {
  margin: 20px;
}

.imgUrlBox,
.detailsImgBox {
  width: 100%;
}

.imgUrlBox {
  margin-bottom: 80px;
}

.imgUrlBoxShow {
  display: flex;
}

.imgUrlBoxShow>div {
  margin: 10px;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px dotted rgb(93, 93, 93);
}

.imgUrlBoxShow>div:hover {
  cursor: pointer;
}

.detailsImgBoxShow>div {
  border: 1px dotted rgb(93, 93, 93);
  margin: 0 auto;
}

.detailsImgBoxShow>div:hover {
  cursor: pointer;
}

.detailsImgBoxShow>div img {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
</style>
